import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, HStack, Link, Stack, Text, } from '@chakra-ui/react';
import { Logo } from '@client/components/branding/Logo';
import { InfoPageDialog } from '@client/components/richText/InfoPageDialog';
import { CLIENT_ROUTES, InfoPageKey } from '@client/constants';
import { displayFontFamily } from '@client/theme';
import { useState } from 'react';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
const hideFooterPages = [CLIENT_ROUTES.checkout];
const SUPPORT_EMAIL = 'support@heirloom.shop';
const SUPPORT_PHONE = '(312) 617-6523';
const SUPPORT_PHONE_TEL = '+13126176523';
const FOOTER_INFO_LINKS = [
    {
        label: 'Shipping & Returns',
        key: InfoPageKey.SHIPPING_RETURNS,
    },
    { label: 'Privacy Policy', key: InfoPageKey.PRIVACY },
    { label: 'Terms of Service', key: InfoPageKey.TERMS_OF_SERVICE },
];
export const Footer = () => {
    const { pathname } = useLocation();
    const [openInfoPage, setOpenInfoPage] = useState(null);
    const hideFooter = hideFooterPages
        .map((page) => `/${page}`)
        .includes(pathname);
    if (hideFooter) {
        return null;
    }
    return (_jsxs(Box, { width: "100%", background: "brand", color: "#FFF", flexShrink: 0, px: { base: 6, md: 10 }, py: 10, fontSize: 18, children: [_jsxs(Flex, { wrap: "wrap", gap: 10, justifyContent: "space-between", maxW: 1000, mx: "auto", children: [_jsxs(Stack, { gap: 0, alignItems: "center", children: [_jsx(Box, { width: 160, children: _jsx(Logo, {}) }), _jsx(Text, { fontFamily: displayFontFamily, fontSize: 22, children: "2026 \u2022 Chicago, IL" })] }), _jsxs(Stack, { gap: 1, minW: 200, children: [_jsx(Text, { fontSize: 24, fontWeight: 600, children: "Contact" }), _jsxs(HStack, { gap: 2.5, children: [_jsx(FaEnvelope, {}), _jsx(Link, { href: `mailto:${SUPPORT_EMAIL}`, color: "#FFF", children: SUPPORT_EMAIL })] }), _jsxs(HStack, { gap: 2.5, children: [_jsx(FaPhoneAlt, {}), _jsx(Link, { href: `tel:${SUPPORT_PHONE_TEL}`, color: "#FFF", children: SUPPORT_PHONE })] })] }), _jsxs(Stack, { gap: 1, minW: 200, children: [_jsx(Text, { fontSize: 24, fontWeight: 600, children: "Info" }), _jsx(Stack, { gap: 0, children: FOOTER_INFO_LINKS.map(({ label, key }) => (_jsx(Link, { color: "#FFF", cursor: "pointer", onClick: () => setOpenInfoPage(key), children: label }, key))) })] })] }), openInfoPage && (_jsx(InfoPageDialog, { infoPageKey: openInfoPage, open: true, onClose: () => setOpenInfoPage(null) }))] }));
};
